export default {
    access_barrier: {
        name: "Access Barrier",
        url: "forestry/access_barrier",
    },
    anchor: {
        name: "Anchor",
        url: "forestry/anchor",
    },
    archaeological_feature: {
        name: "Archaeological Feature",
        url: "forestry/archaeological_feature",
    },
    avalanche: {
        name: "Avalanche",
        url: "forestry/avalanche",
    },
    backspar: {
        name: "Backspar",
        url: "forestry/backspar",
    },
    barrier_to_fish_passage: {
        name: "Barrier To Fish Passage",
        url: "forestry/barrier_to_fish_passage",
    },
    block_boundary: {
        name: "Block Boundary",
        url: "forestry/block_boundary",
    },
    borrow_pit: {
        name: "Borrow Pit",
        url: "forestry/borrow_pit",
    },
    bridge: {
        name: "Bridge",
        url: "forestry/bridge",
    },
    cattle_gaurd: {
        name: "Cattle Gaurd",
        url: "forestry/cattle_gaurd",
    },
    cliff: {
        name: "Cliff",
        url: "forestry/cliff",
    },
    coarse_woody_debris: {
        name: "Coarse Woody Debris",
        url: "forestry/coarse_woody_debris",
    },
    construction_type: {
        name: "Construction Type",
        url: "forestry/construction_type",
    },
    cross_ditch: {
        name: "Cross Ditch",
        url: "forestry/cross_ditch",
    },
    culvert: {
        name: "Culvert",
        url: "forestry/culvert",
    },
    dam: {
        name: "Dam",
        url: "forestry/dam",
    },
    deactivation_treatment: {
        name: "Deactivation Treatment",
        url: "forestry/deactivation_treatment",
    },
    deflection_line: {
        name: "Deflection Line",
        url: "forestry/deflection_line",
    },
    den: {
        name: "Den",
        url: "forestry/den",
    },
    designated_crossing: {
        name: "Designated Crossing",
        url: "forestry/designated_crossing",
    },
    distance_marker: {
        name: "Distance Marker",
        url: "forestry/distance_marker",
    },
    ditch_block: {
        name: "Ditch Block",
        url: "forestry/ditch_block",
    },
    ditching_treatment: {
        name: "Ditching Treatment",
        url: "forestry/ditching_treatment",
    },
    draw_swale: {
        name: "Draw Swale",
        url: "forestry/draw_swale",
    },
    end_haul_treatment: {
        name: "End Haul Treatment",
        url: "forestry/end_haul_treatment",
    },
    falling_corner: {
        name: "Falling Corner",
        url: "forestry/falling_corner",
    },
    fence: {
        name: "Fence",
        url: "forestry/fence",
    },
    flight_path: {
        name: "Flight Path",
        url: "forestry/flight_path",
    },
    forest_health_observation: {
        name: "Forest Health Observation",
        url: "forestry/forest_health_observation",
    },
    gate: {
        name: "Gate",
        url: "forestry/gate",
    },
    geo_textile_treatment: {
        name: "Geo Textile Treatment",
        url: "forestry/geo_textile_treatment",
    },
    geological_survey_monument: {
        name: "Geological Survey Monument",
        url: "forestry/geological_survey_monument",
    },
    grading_treatment: {
        name: "Grading Treatment",
        url: "forestry/grading_treatment",
    },
    gully: {
        name: "Gully",
        url: "forestry/gully",
    },
    habitat_observation: {
        name: "Habitat Observation",
        url: "forestry/habitat_observation",
    },
    hand_falling_area: {
        name: "Hand Falling Area",
        url: "forestry/hand_falling_area",
    },
    harvest_method: {
        name: "Harvest Method",
        url: "forestry/harvest_method",
    },
    harvest_method_1: {
        name: "Harvest Method 1",
        url: "forestry/harvest_method_1",
    },
    harvest_method_2: {
        name: "Harvest Method 2",
        url: "forestry/harvest_method_2",
    },
    helidrop: {
        name: "Helidrop",
        url: "forestry/helidrop",
    },
    helipad: {
        name: "Helipad",
        url: "forestry/helipad",
    },
    intermediate_support: {
        name: "Intermediate Support",
        url: "forestry/intermediate_support",
    },
    invasive_plant: {
        name: "Invasive Plant",
        url: "forestry/invasive_plant",
    },
    lake: {
        name: "Lake",
        url: "forestry/lake",
    },
    landing: {
        name: "Landing",
        url: "forestry/landing",
    },
    leave_tree: {
        name: "Leave Tree",
        url: "forestry/leave_tree",
    },
    machine_free_zone: {
        name: "Machine Free Zone",
        url: "forestry/machine_free_zone",
    },
    mineral_claim_post: {
        name: "Mineral Claim Post",
        url: "forestry/mineral_claim_post",
    },
    mineshaft: {
        name: "Mineshaft",
        url: "forestry/mineshaft",
    },
    nest: {
        name: "Nest",
        url: "forestry/nest",
    },
    operational_trail: {
        name: "Operational Trail",
        url: "forestry/operational_trail",
    },
    parking_area: {
        name: "Parking Area",
        url: "forestry/parking_area",
    },
    pipeline: {
        name: "Pipeline",
        url: "forestry/pipeline",
    },
    pipeline_crossing: {
        name: "Pipeline Crossing",
        url: "forestry/pipeline_crossing",
    },
    plot: {
        name: "Plot",
        url: "forestry/plot",
    },
    private_land: {
        name: "Private Land",
        url: "forestry/private_land",
    },
    puddle: {
        name: "Puddle",
        url: "forestry/puddle",
    },
    pullout: {
        name: "Pullout",
        url: "forestry/pullout",
    },
    reach_break: {
        name: "Reach Break",
        url: "forestry/reach_break",
    },
    rec_area: {
        name: "Rec Area",
        url: "forestry/rec_area",
    },
    reference_tree: {
        name: "Reference Tree",
        url: "forestry/reference_tree",
    },
    reserve: {
        name: "Reserve",
        url: "forestry/reserve",
    },
    ridge: {
        name: "Ridge",
        url: "forestry/ridge",
    },
    right_of_way: {
        name: "Right Of Way",
        url: "forestry/right_of_way",
    },
    riparian_management_unit: {
        name: "Riparian Management Unit",
        url: "forestry/riparian_management_unit",
    },
    road: {
        name: "Road",
        url: "forestry/road",
    },
    road_construction_support: {
        name: "Road Construction Support",
        url: "forestry/road_construction_support",
    },
    road_gate: {
        name: "Road Gate",
        url: "forestry/road_gate",
    },
    road_hub: {
        name: "Road Hub",
        url: "forestry/road_hub",
    },
    roadside_decking: {
        name: "Roadside Decking",
        url: "forestry/roadside_decking",
    },
    rock: {
        name: "Rock",
        url: "forestry/rock",
    },
    rock_blasting_treatment: {
        name: "Rock Blasting Treatment",
        url: "forestry/rock_blasting_treatment",
    },
    rock_excavation: {
        name: "Rock Excavation",
        url: "forestry/rock_excavation",
    },
    salt_lick: {
        name: "Salt Lick",
        url: "forestry/salt_lick",
    },
    seep: {
        name: "Seep",
        url: "forestry/seep",
    },
    shrubbing_treatment: {
        name: "Shrubbing Treatment",
        url: "forestry/shrubbing_treatment",
    },
    sign: {
        name: "Sign",
        url: "forestry/sign",
    },
    site: {
        name: "Site",
        url: "forestry/site",
    },
    skid_yard_direction: {
        name: "Skid Yard Direction",
        url: "forestry/skid_yard_direction",
    },
    slash_pile: {
        name: "Slash Pile",
        url: "forestry/slash_pile",
    },
    slide: {
        name: "Slide",
        url: "forestry/slide",
    },
    slump: {
        name: "Slump",
        url: "forestry/slump",
    },
    species_observation_aquatic: {
        name: "Species Observation Aquatic",
        url: "forestry/species_observation_aquatic",
    },
    species_observation_land: {
        name: "Species Observation Land",
        url: "forestry/species_observation_land",
    },
    spoil_site: {
        name: "Spoil Site",
        url: "forestry/spoil_site",
    },
    staging: {
        name: "Staging",
        url: "forestry/staging",
    },
    stream: {
        name: "Stream",
        url: "forestry/stream",
    },
    structure: {
        name: "Structure",
        url: "forestry/structure",
    },
    stubbing_treatment: {
        name: "Stubbing Treatment",
        url: "forestry/stubbing_treatment",
    },
    surfacing_treatment: {
        name: "Surfacing Treatment",
        url: "forestry/surfacing_treatment",
    },
    timber_type: {
        name: "Timber Type",
        url: "forestry/timber_type",
    },
    trail: {
        name: "Trail",
        url: "forestry/trail",
    },
    transmission_line: {
        name: "Transmission Line",
        url: "forestry/transmission_line",
    },
    transmission_line_tower: {
        name: "Transmission Line Tower",
        url: "forestry/transmission_line_tower",
    },
    trapline: {
        name: "Trapline",
        url: "forestry/trapline",
    },
    treatment_unit: {
        name: "Treatment Unit",
        url: "forestry/treatment_unit",
    },
    water_bar: {
        name: "Water Bar",
        url: "forestry/water_bar",
    },
    water_diversion: {
        name: "Water Diversion",
        url: "forestry/water_diversion",
    },
    wetland: {
        name: "Wetland",
        url: "forestry/wetland",
    },
    wildlife_trail: {
        name: "Wildlife Trail",
        url: "forestry/wildlife_trail",
    },
    windthrow: {
        name: "Windthrow",
        url: "forestry/windthrow",
    },
    yarder_setting: {
        name: "Yarder Setting",
        url: "forestry/yarder_setting",
    },
}
